// /admin/v1/fulfillments — 权益履约台账 + 补推 (benefit-fulfillment).
// Mirrors backend handlers/fulfillment/admin.go (MountAdmin → /fulfillments*).
//
//   GET  /admin/v1/fulfillments            — 台账 (?status=&limit=&cursor=)
//   POST /admin/v1/fulfillments/:id/retry  — 手动补推 (重置 attempts, 重启 workflow)

import { list, post } from './client';
import type { ListResult } from './client';

/** model.Fulfillment — 一条权益履约单. */
export interface Fulfillment {
  id: string;
  order_id: string;
  user_id: string;
  app_id: number;
  provider: string;
  phone: string;
  sku_code: string;
  /** config.fulfillment.params 快照 (含 card-api 的 product_code/card_type 等). */
  params?: Record<string, unknown> | null;
  status: 'pending' | 'pushed' | 'confirmed' | 'failed' | 'manual';
  attempts: number;
  /** 供应商单号 (card-api 的 OrderNo; cardkey 是分配到的卡 id). */
  external_id?: string | null;
  last_error?: string | null;
  pushed_at?: string | null;
  confirmed_at?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface ListFulfillmentsQuery {
  status?: string;
  cursor?: string;
  limit?: number;
}

export function listFulfillments(q: ListFulfillmentsQuery = {}): Promise<ListResult<Fulfillment>> {
  return list<Fulfillment>('/admin/v1/fulfillments', q);
}

/** 手动补推一条 failed 履约单 (重置 attempts → 重启 WF_FULFILLMENT). */
export function retryFulfillment(id: string): Promise<Fulfillment> {
  return post<Fulfillment>(`/admin/v1/fulfillments/${id}/retry`);
}
